import request from '@/utils/request';
//分页查询直营市场会员数据
export function queryDirectMarketMemberPage(param) {
  return request('/member-report/queryDirectMarketMemberPage', {
    method: 'POST',
    data: param,
  });
}
// 获取门店树形列表
export function getStoreTreeList() {
  return request('/store/queryTreeList', {
    method: 'GET',
  });
}
// 获取门店树形列表
export function getStoreAndArea() {
  return request('/user/storeAndArea', {
    method: 'GET',
  });
}

// 导出
export function exportDirectMarketMember(param) {
  return request('/member-report/exportDirectMarketMember', {
    method: 'POST',
    data: param,
  });
}
